import { getApiUrl, JOB_API_URL, getUrl } from '../../util/api/api'
import type { JobContent } from '../../../state/reducers/jobs/jobs'
import { StatusCodes } from 'http-status-codes'

type Args = {
  id: string
  jobContent: JobContent,
}

const updateDraft = async ({ id, jobContent }: Args): Promise<any> => {

  const fetchResponse = await fetch(
      getUrl(`/dashboard/api/job/provide-job-content/${id}`),
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify(jobContent),
      }
  )

  if (fetchResponse?.ok) {
    return Promise.resolve({ status: StatusCodes.ACCEPTED })
  } else {
    return Promise.reject(fetchResponse ? { status: fetchResponse.status, data: fetchResponse.statusText } : null)
  }
}

export default updateDraft
